import { styled } from '@mui/joy';
import Textarea from '@mui/joy/Textarea';

import { commonBaseInputStyles } from '@components/BaseStyledComponents/common';

export const BaseTextarea = styled(Textarea)(({ theme }) => ({
  ...commonBaseInputStyles(theme),
}));
